import { siteConfig } from "../config/site";
import { FormattedText } from "./FormattedText";

export function WorkSection() {
  return (
    <section
      id="work"
      className="border-t border-ink/15"
      aria-labelledby="work-title"
    >
      <div className="content-section">
        <div className="section-heading">
          <h2 id="work-title" className="section-title">
            {siteConfig.work.heading}
          </h2>
          <p className="section-intro">
            <FormattedText>{siteConfig.work.intro}</FormattedText>
          </p>
        </div>
        <div>
          {siteConfig.work.areas.map((area) => (
            <article key={area.id} className="content-row">
              <div>
                <h3
                  itemProp="knowsAbout"
                  className="text-xl font-medium tracking-[-.025em] sm:text-2xl"
                >
                  {area.title}
                </h3>
                <p className="mt-4 max-w-[55ch] text-[15px] leading-7 text-ink/70">
                  <FormattedText>{area.description}</FormattedText>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
